module.exports = __webpack_public_path__ + "img/sprong-icon.03cf2f9f.png";